function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h7.5l.309.309h14.381l.31-.309h7.5v15h-7.5l-.309-.309H7.809l-.309.309H0V7.5Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,7.5h15v15H7.5V7.5ZM15.281,21.344l-.141-2.697c-.008-.164.119-.303.283-.31.021,0,.043,0,.064.004l2.684.472-.362-1c-.03-.082-.005-.173.062-.228l2.941-2.381-.663-.309c-.093-.044-.138-.15-.106-.247l.581-1.787-1.694.359c-.095.02-.19-.03-.228-.119l-.328-.772-1.322,1.419c-.077.081-.206.085-.287.008-.05-.048-.073-.118-.06-.186l.638-3.287-1.022.591c-.097.057-.221.024-.278-.073-.002-.004-.004-.008-.006-.012l-1.037-2.039-1.038,2.037c-.05.1-.172.141-.273.091-.004-.002-.008-.004-.012-.006l-1.022-.591.637,3.287c.021.11-.051.217-.161.238-.068.013-.138-.009-.186-.06l-1.322-1.419-.328.772c-.038.089-.134.138-.228.119l-1.694-.359.581,1.787c.032.097-.014.203-.106.247l-.663.309,2.941,2.381c.068.055.093.147.062.228l-.363,1,2.684-.472c.162-.028.315.081.343.242.004.021.005.043.004.064l-.141,2.697h.566v.002Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/CA.0296722f9a009e91fbe3335e23f0f485.svg";
export { ForwardRef as ReactComponent };